import { formatSecondsToUTCtime } from "@memorang/helpers/common";
import type { ReportDetails } from "@memorang/types";

type ReportStatsDetails = Pick<
	ReportDetails,
	| "accuracy"
	| "answered"
	| "avgSpeed"
	| "numCorrect"
	| "numHints"
	| "numPointsEarned"
	| "numQuestions"
	| "numTotalPoints"
> & {
	timeElapsed?: number | null;
};

const getElapsedSeconds = (seconds?: number | null) => {
	if (typeof seconds !== "number" || !Number.isFinite(seconds)) {
		return 0;
	}

	return seconds;
};

export const getReportStatsValueMap = (
	reportDetails: ReportStatsDetails,
): Record<string, string> => {
	const timeElapsed = getElapsedSeconds(reportDetails.timeElapsed);

	return {
		correct: `${reportDetails.numCorrect} / ${reportDetails.numQuestions}`,
		accuracy: `${Math.round(reportDetails.accuracy)}%`,
		duration: formatSecondsToUTCtime(timeElapsed),
		avgSpeed: `${Number(reportDetails.avgSpeed).toFixed(1)} secs`,
		hintsUsed: `${reportDetails.numHints}`,
		pointsEarned: `${reportDetails.numPointsEarned} / ${reportDetails.numTotalPoints}`,
		answered: `${reportDetails.answered}`,
		timeElapsed: `${timeElapsed.toFixed(0)}`,
	};
};
